var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routeGeometry)?_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.clickSaveGpx}},[_c('v-icon',[_vm._v("cloud_download")]),_vm._v("\n      "+_vm._s(_vm.$t('Save as GPX file'))+".\n")],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c8f8f8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/routing/DownloadGPX.vue
// module id = R8ss
// module chunks = 1